import { globalVariables } from "helper/globalVariables";
import { pendingPayment, successPayment } from "helper/icons";
import { DecoratedPrice } from "helper/utility";
import moment from "moment";
import { forwardRef } from "react";
import Dropdown from "shared/Components/dropdown";
import Loader from "shared/Components/loader";
import Modal from "shared/Components/modal";

export const PaymentDetailModal = forwardRef(
  ({ data, onChangeStatus, statusLoading }, ref) => {
    const SectionItem = ({ heading, value }) => (
      <div className="py-[5px] mt-[10px]">
        <p className="text-sm text-gray-600">{heading}</p>
        <p className="text-md text-bold mt-1">{value}</p>
      </div>
    );

    const PaymentStatusButton = () => {
      if (data?.payment_status === "Unpaid") {
        return (
          <Dropdown
            width={"w-[140px] mt-[5px]"}
            placeholder="Unpaid"
            dropdownOptions={[globalVariables.markAsPaid]}
            customContent="flex justify-center"
            transform="left-0 z-200"
            onChange={(option) => onChangeStatus(option)}
          />
        );
      }

      if (data?.payment_status === "Paid") {
        return (
          <div className="flex justify-center border rounded-md py-2 border-[#17B26A] bg-[#F6FEF9] w-[150px]  mt-[5px]">
            <span className="text-base font-regular text-[#17B26A]">
              {globalVariables.paid}
            </span>
            <img src={successPayment} className="ml-1" alt="" />
          </div>
        );
      } else if (data?.payment_status === "Mark as Paid") {
        return (
          <div className="flex justify-center border rounded-md py-2 border-gray-300 bg-white w-[150px]  mt-[5px]">
            <span className="text-base font-regular text-gray">
              {globalVariables.markAsPaid}
            </span>
            <img src={pendingPayment} className="ml-1" alt="" />
          </div>
        );
      }
    };

    return (
      <Modal ref={ref} overflow="overflow-visible">
        <div className="w-80 mt-[15px]">
          <SectionItem
            heading={globalVariables.ownerName}
            value={data?.owner_name}
          />
          <SectionItem
            heading={globalVariables.dogName}
            value={data?.call_name}
          />
          <SectionItem heading={globalVariables.email} value={data?.email} />
          <SectionItem
            heading={globalVariables.phoneNumber}
            value={data?.phone_number}
          />
          <SectionItem
            heading={globalVariables.dateOfJoining}
            value={moment(data?.dateOfJoining).format("DD/MM/YYYY")}
          />
          <SectionItem
            heading={globalVariables.amount}
            value={DecoratedPrice(data?.amount)}
          />
          <div className="py-[5px] mt-[10px]">
            <p className="text-sm text-gray-600">
              {globalVariables.paymentStatus}
            </p>
            {statusLoading ? <Loader /> : <PaymentStatusButton />}
          </div>
        </div>
      </Modal>
    );
  }
);
